import React from 'react'
import './header.css'
import {useNavigate} from 'react-router-dom'
import { useLocation } from 'react-router-dom';
import swal from "sweetalert";
import {WalletContext} from '../../context/WalletContext'
import {onConnect} from '../../utils/WalletConnections'
function Header() {

    const {walletAddress,setWalletAddress,provider,setProvider,auth,setAuth,setEGBXbal,setGDBXbal}=React.useContext(WalletContext)
  
  
    async function onWalletConnect() {
        onConnect().then(res=>
            {
                setWalletAddress(res.walletAddress)
                setAuth(res.auth)
                setGDBXbal((res.GDBX/10**18))
                setEGBXbal(res.EGBX)
                setProvider(res.Provider)
            }).catch(err=>
                {
                    swal({
                        title: "Error Found",
                        text: err.err,
                        type: "error",
                        showCancelButton: false,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Ok",
                        closeOnConfirm: false,
                      });
                })
    }
    const navigate=useNavigate()
    let location = useLocation();
   
    const [open,setOpen]=React.useState(false)
    React.useEffect(()=>
    {
        console.log(location.pathname)
    })
  return (
    <>
    <div className='header'>
        <div className='header-left'>
            <img src='/assets/Logo.png' className='header-logo' onClick={()=>navigate("/")}/>
            <img src='/assets/HamBurger.png' className='header-hamburger' onClick={()=>setOpen(!open)}/>
         
        </div>
        
        <img src='/assets/BuxSwapLogo.png' className='header-logo-mobile'/>
    
        <div className='header-center'>
        <div className='header-links'>
            <img src='/assets/eggheadstore.png'/>
        </div>
            <div className='seperator'></div>
            
        <div className='header-links' onClick={()=>navigate("/")}>
            <p>Home</p>
            <div className='line'   style={{visibility:location.pathname=='/'?'visible':'hidden'}}></div>
            </div>
            <div className='header-links' onClick={()=>navigate("/swap")}>
            <p  style={{fontFamily:location.pathname=='/swap'?'bold':'Normal'}}>Swap</p>
            <div className='line'  style={{visibility:location.pathname=='/swap'?'visible':'hidden'}}></div>
            </div>
            <div className='header-links' onClick={()=>navigate("/about")}>
            <p style={{fontFamily:location.pathname=='/about'?'bold':'Normal'}}>About</p>
            <div className='line'  style={{visibility:location.pathname=='/about'?'visible':'hidden'}}></div>
            </div>
            <div className='header-links' onClick={()=>navigate("/contact")}>
            <p style={{fontFamily:location.pathname=='/contact'?'bold':'Normal'}}>Contact</p>
            <div className='line'  style={{visibility:location.pathname=='/contact'?'visible':'hidden'}}></div>
            </div>
          
        </div>
        <div className='header-right'>
            <div className='header-connectWallet' onClick={()=>onWalletConnect()}>
            <p> {walletAddress?walletAddress.substring(0,8)+'...':'Connect wallet'}</p>
            </div>
            
        <div className='header-right-mobile' onClick={()=>navigate('/swap')}>
            <img src='/assets/eggheadstore.png'/>
       
            </div>
            <div className='header-connectWallet-mobile' onClick={()=>onWalletConnect()}>
            <img src='/assets/MetaMask.png'/>
       
            </div>
        </div>

    </div>
    <div className='header-mob-overlay' style={{display:open?'block':'none'}} onClick={() => setOpen(false)} ></div>

    <div className='header-mobile' style={{display:open?'flex':'none'}}>
        <div className='header-mobile-container' style={{display:open?'block':'none'}}>
            
            
            <p onClick={()=>
                {
                    navigate("/")
                    setOpen(false) 
                }
               }>Home</p>
            <p onClick={()=>
                {
                    navigate("/swap")
                    setOpen(false)
                }
            }>Swap</p>
            <p onClick={()=>
                {
                    navigate("/about")
                    setOpen(false)
                }}>About</p>
            <p onClick={()=>
                {
                    navigate("/contact")
                    setOpen(false)
                }} style={{borderBottomWidth:'0px'}}>Contact</p>
        </div>
    </div>
    </>
  )
}

export default Header